let add_event_listener_into_sidecart_remove_icon=()=>{
  let th_pb_cb_sidecart_p_grid_remove_product_icons=document.querySelectorAll('.th_pb_cb_sidecart_p_grid_remove_product');
  th_pb_cb_sidecart_p_grid_remove_product_icons.forEach((th_bb_sidecart_remove_icon)=>{
    th_bb_sidecart_remove_icon.addEventListener('click',()=>{
      th_add_product_price_when_product_is_out_of_stock();
    })
  })
}

let th_add_product_price_when_product_is_out_of_stock=()=>{
   let th_grid_product_select_elements=document.querySelectorAll('.th_pb_cb_p_grid_main_variant');
   th_grid_product_select_elements.forEach((th_pro_select_element)=>{
     if(th_pro_select_element.length==0){
       let th_product_grid_index=parseFloat(th_pro_select_element.closest('.th_pb_cb_p_grid_column').querySelector('.th_pb_cb_p_grid_add ').dataset.grid_product_index)
       let th_product_grid_price_element=th_pro_select_element.closest('.th_pb_cb_p_grid_column').querySelector('.th_pb_cb_p_grid_price_p')
       let th_sale_price=parseFloat(th_product_data_array[th_index1][th_product_grid_index].all_variants[0].price);
       th_product_grid_price_element.innerHTML=returns_format_money(th_sale_price*100)
     }
   })
}


let th_add_event_listeners=()=>{
  let th_product_grid_first_addtocart_btns=document.querySelectorAll('.th_pb_cb_p_grid_add_btn');
  let th_pb_cb_p_grid_add_qty_minus_btns=document.querySelectorAll('.th_pb_cb_p_grid_add_qty_minus');
  
    th_product_grid_first_addtocart_btns.forEach((th_bb_pr_first_add_btn)=>{
      th_bb_pr_first_add_btn.addEventListener('click',()=>{
        add_event_listener_into_sidecart_remove_icon();
      })
    })

  th_pb_cb_p_grid_add_qty_minus_btns.forEach((th_bb_minus_btn)=>{
    th_bb_minus_btn.addEventListener('click',()=>{
      th_add_product_price_when_product_is_out_of_stock();
    })
  })
}
let wc_bb_single_available=(result_value)=>{
    th_add_event_listeners();
    th_add_product_price_when_product_is_out_of_stock();
}
let th_bb_section_change_without_API_call=()=>{
    th_add_event_listeners();
    th_add_product_price_when_product_is_out_of_stock();
}
let wc_bb_single_available_other_products=()=>{
   th_add_event_listeners();
   th_add_product_price_when_product_is_out_of_stock();
}

window.$search_items_updated=()=>{
   th_add_event_listeners();
   th_add_product_price_when_product_is_out_of_stock();
}
window.$th_search_results_back=()=>{
   th_add_event_listeners();
   th_add_product_price_when_product_is_out_of_stock();
}



//shortcode buildbox
let th_shortcode_bb_add_product_price_for_the_sold_out_product=($wcpb_bb_api_json)=>{
  let wc_pb_bb_section_id=document.querySelector(`.wc_pb_bb_section_id[data-bbid="${$wcpb_bb_api_json.bundle_key}"]`);
  let th_shor_bb_select_elements=wc_pb_bb_section_id.querySelectorAll('.th_pb_cb_p_grid_main_variant');
  let th_bb_current_section_product=[];
  if($wcpb_bb_api_json.bundle_structure_type=='0'){
        th_bb_current_section_product.push(...$wcpb_bb_api_json.products)
  }else{
      th_bb_current_section_product.push(...$wcpb_bb_api_json.sections[$wcpb_bb_api_json.wcpb_bb_selected_section_count].products)
  }
  th_shor_bb_select_elements.forEach((th_shor_bb_select_element)=>{
    if(th_shor_bb_select_element.length==0){
    let th_bb_product_title_anchor=th_shor_bb_select_element.closest('.th_pb_cb_p_grid_column').querySelector('.th_pb_cb_p_grid_figure a')
    let th_bb_product_handle=th_bb_product_title_anchor.href.split('/products/')[1];
      th_bb_current_section_product.forEach((product_obj)=>{
        if(product_obj.handle==th_bb_product_handle){
          let th_pb_cb_p_grid_column=th_shor_bb_select_element.closest('.th_pb_cb_p_grid_column');
          let th_pb_cb_p_grid_column_price_element=th_pb_cb_p_grid_column.querySelector('.th_pb_main_price .money');
          let th_sold_out_variant_price=parseFloat(product_obj.variants[0].price)
          th_pb_cb_p_grid_column_price_element.innerText=returns_format_money_shorcode_bb(th_sold_out_variant_price*100);
        }
      })
    }
    
  })
}
window.$wcpb_bb_custom_callback_event=($wcpb_bb_api_json)=>{
  var th_wc_cs_shop_money=document.querySelector('#th_shop_money').getAttribute('content');
  var Shopify = Shopify || {}; Shopify.money_format = th_wc_cs_shop_money, Shopify.formatMoney = function (a, e) { "string" == typeof a && (a = a.replace(".", "")); var o = "", r = /\{\{\s*(\w+)\s*\}\}/, t = e || this.money_format; function n(a, e) { return void 0 === a ? e : a } function i(a, e, o, r) { if (e = n(e, 2), o = n(o, ","), r = n(r, "."), isNaN(a) || null == a) return 0; var t = (a = (a / 100).toFixed(e)).split("."); return t[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (t[1] ? r + t[1] : "") } switch (t.match(r)[1]) { case "amount": o = i(a, 2); break; case "amount_no_decimals": o = i(a, 0); break; case "amount_with_comma_separator": o = i(a, 2, ".", ","); break; case "amount_no_decimals_with_comma_separator": o = i(a, 0, ".", ",") }return t.replace(r, o) };
   window.returns_format_money_shorcode_bb = (final) => { return Shopify.formatMoney(final, th_wc_cs_shop_money) }
  th_shortcode_bb_add_product_price_for_the_sold_out_product($wcpb_bb_api_json);
}